import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-[18px] md:px-[72px] md:py-[22px] bg-[rgba(8,8,8,0.93)] backdrop-blur-[20px] border-b border-[rgba(255,255,255,0.04)]" data-id="element-189">
      <div className="font-serif text-xl font-semibold tracking-wide text-cream" data-id="element-190">
        Get<em className="not-italic text-gold-bright" data-id="element-191">More</em>Scores
      </div>
      <div className="flex items-center gap-8" data-id="element-192">
        <a href="#proceso" className="hidden md:block text-[13px] uppercase tracking-widest text-muted hover:text-cream transition-colors duration-200" data-id="element-193">
          Proceso
        </a>
        <a href="#resultados" className="hidden md:block text-[13px] uppercase tracking-widest text-muted hover:text-cream transition-colors duration-200" data-id="element-194">
          Resultados
        </a>
        <a href="#apply" className="inline-flex items-center gap-2 border border-gold text-gold text-xs font-medium uppercase tracking-[1.5px] py-[11px] px-7 transition-all duration-250 hover:bg-gold hover:text-ink" data-id="element-195">
          Aplicar Ahora
        </a>
      </div>
    </nav>;
}